// All European ISO2 codes (including transcontinental)
export const EUROPE_ISO2 = new Set<string>([
	"AL",
	"AD",
	"AM",
	"AT",
	"AZ",
	"BY",
	"BE",
	"BA",
	"BG",
	"HR",
	"CY",
	"CZ",
	"DK",
	"EE",
	"FI",
	"FR",
	"GE",
	// "DE",
	"GR",
	"HU",
	"IS",
	"IE",
	"IT",
	"KZ",
	"XK",
	"LV",
	"LI",
	"LT",
	"LU",
	"MT",
	"MD",
	"MC",
	"ME",
	// "NL",
	"MK",
	"NO",
	"PL",
	"PT",
	"RO",
	"RU",
	"SM",
	"RS",
	"SK",
	"SI",
	"ES",
	"SE",
	"CH",
	"TR",
	"UA",
	"GB",
	"VA",
]);

export const currencySymbols: Record<string, string> = {
	INR: "₹",
	USD: "$",
	GBP: "£",
	CAD: "CA$",
	EUR: "€",
	SGD: "S$",
	AUD: "A$",
	AED: "د.إ",
};

export const COUNTRY_DEFAULTS: Record<string, any> = {
	IN: {
		currency: "INR",
		unitSystem: "Metric",
		lengthUnit: "mm",
		massUnit: "kg",
		areaUnit: "mm2",
	},
	US: {
		currency: "USD",
		unitSystem: "Imperial",
		lengthUnit: "inch",
		massUnit: "lb",
		areaUnit: "in2",
	},
	GB: {
		currency: "GBP",
		unitSystem: "Imperial",
		lengthUnit: "inch",
		massUnit: "lb",
		areaUnit: "in2",
	},
	CA: {
		currency: "CAD",
		unitSystem: "Imperial",
		lengthUnit: "inch",
		massUnit: "lb",
		areaUnit: "in2",
	},
	NL: {
		currency: "EUR",
		unitSystem: "Metric",
		lengthUnit: "mm",
		massUnit: "kg",
		areaUnit: "mm2",
	},
	DE: {
		currency: "EUR",
		unitSystem: "Metric",
		lengthUnit: "mm",
		massUnit: "kg",
		areaUnit: "mm2",
	},
	SG: {
		currency: "SGD",
		unitSystem: "Metric",
		lengthUnit: "mm",
		massUnit: "kg",
		areaUnit: "mm2",
	},
	AU: {
		currency: "AUD",
		unitSystem: "Metric",
		lengthUnit: "mm",
		massUnit: "kg",
		areaUnit: "mm2",
	},
	AE: {
		currency: "AED",
		unitSystem: "Metric",
		lengthUnit: "mm",
		massUnit: "kg",
		areaUnit: "mm2",
	},

	// Buckets
	EU_OTHER: {
		currency: "EUR",
		unitSystem: "Metric",
		lengthUnit: "mm",
		massUnit: "kg",
		areaUnit: "mm2",
	},
	ALL_OTHER: {
		currency: "USD",
		unitSystem: "Metric",
		lengthUnit: "mm",
		massUnit: "kg",
		areaUnit: "mm2",
	},
};

export function resolveLocaleDefaults(countryISO2?: string): any {
	const c = (countryISO2 || "").toUpperCase();

	// Direct match (IN, US, GB, etc.)
	if (COUNTRY_DEFAULTS[c]) {
		return COUNTRY_DEFAULTS[c];
	}

	// European country → EU_OTHER
	if (EUROPE_ISO2.has(c)) {
		return COUNTRY_DEFAULTS["EU_OTHER"];
	}

	// Everything else
	return COUNTRY_DEFAULTS["ALL_OTHER"];
}
